import { render, staticRenderFns } from "./addNew.vue?vue&type=template&id=6ba24f2c&"
import script from "./addNew.vue?vue&type=script&lang=js&"
export * from "./addNew.vue?vue&type=script&lang=js&"
import style0 from "./addNew.vue?vue&type=style&index=0&id=6ba24f2c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports